export default "__VITE_PUBLIC_ASSET__5bac6c4f__"